import { AxiosResponse } from 'axios';

import { DetailSchedulerResponse } from '../pages/inventory-control/Home.type';
import { axiosInstance } from './axios.config';
import { ResponseREST } from './response.type';

interface ResponseSuccessGetDetailScheduler extends ResponseREST {
	data: Array<DetailSchedulerResponse>;
}

export const getDetailScheduler = async (
	id: number,
): Promise<ResponseSuccessGetDetailScheduler> => {
	return axiosInstance
		.get(`detail-scheduler/${id}`)
		.then((res: AxiosResponse<ResponseSuccessGetDetailScheduler>) => res.data)
		.catch((err) => err);
};
